// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseSubHeader__root___3bQVc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseSubHeader/EnterpriseSubHeader.scss
// module id = 1025
// module chunks = 0